import React, { Component } from "react";

// Redux
import { connect } from "react-redux";

import { Row, Col } from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';

const isValidRut = rut => {
  if (!rut) {
    return false;
  }

  const normalizedRut = rut.replace(/[.\-\s]/g, '').toUpperCase();

  if (!/^\d{7,8}[0-9K]$/.test(normalizedRut)) {
    return false;
  }

  const rutNumber = normalizedRut.slice(0, -1);
  const verifier = normalizedRut.slice(-1);
  let multiplier = 2;
  let sum = 0;

  for (let i = rutNumber.length - 1; i >= 0; i -= 1) {
    sum += Number(rutNumber[i]) * multiplier;
    multiplier = multiplier === 7 ? 2 : multiplier + 1;
  }

  const expectedVerifierValue = 11 - (sum % 11);
  const expectedVerifier = expectedVerifierValue === 11
    ? '0'
    : expectedVerifierValue === 10
      ? 'K'
      : String(expectedVerifierValue);

  return verifier === expectedVerifier;
};

class Datos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validated: false,
      values: {
        firstName: '',
        lastName: '',
        docType: '',
        passport: '',
        dni: '',
        rut: '',
        gender: '',
        nationality: '',
        phone: '',
        email: '',
        acceptTerms: ''
      },
      passport: null
    };

    this.formRef = React.createRef();
  }

isValidated() {
  // Si el ref existe y Formik lo expone, usa el estado de validez real del form
  if (this.formRef.current && typeof this.formRef.current.isValid === 'boolean') {
    return this.formRef.current.isValid;
  }
  // Fallback: usa el estado local
  return this.state.validated;
}

  handleChange(values) {
    setTimeout(function () {
      this.setState({ validated: this.formRef.current.isValid, values });
    }.bind(this), 100);
  }

  handleFile(file) {
    this.setState({ passport: file });
  }

  render() {
    return (
      <React.Fragment>
        <Formik
          validateOnMount={true}
          innerRef={this.formRef}
          initialValues={{
            firstName: '',
            lastName: '',
            docType: '',
            passport: '',
            dni: '',
            rut: '',
            phone: '',
            email: '',
            gender: '',
            nationality: '',
            acceptTerms: ''
          }}
          validationSchema={Yup.object().shape({
            firstName: Yup.string()
              .required('El nombre es requerido'),
            lastName: Yup.string()
              .required('El apellido es requerido'),
            docType: Yup.string().required(),
            passport: Yup.string().when('docType', {
              is: 'pasaporte',
              then: Yup.string().required('El Pasaporte es requerido'),
              otherwise: Yup.string()
            }),
            dni: Yup.string().when('docType', {
              is: 'dni',
              then: Yup.string().required('El DNI es requerido'),
              otherwise: Yup.string()
            }),
            rut: Yup.string().when('docType', {
              is: 'rut',
              then: Yup.string()
                .required('El RUT es requerido')
                .test('valid-rut', 'El RUT es inválido', isValidRut),
              otherwise: Yup.string()
            }),
            phone: Yup.string()
              .required('El teléfono es requerido'),
            email: Yup.string()
              .email('El email es inválido')
              .required('El email es requerido'),
            gender: Yup.string()
              .required('El género es requerido'),
            nationality: Yup.string()
              .required('La nacionalidad es requerida'),
            acceptTerms: Yup.string()
          })}>
          {({ values, handleChange: formikHandleChange, setFieldValue }) => (
            <Form onKeyUp={() => this.handleChange(values)}>
              <Row>
                <Col>
                  <div className="alert alert-info">
                    <strong>Por favor, complete los campos marcados con <span className="text-danger">*</span></strong>
                  </div>
                </Col>
              </Row>
              <Row className="mt-5">
                <Col>
                  <div className="form-group">
                    <label>Nombre <span className="text-danger">*</span></label>
                    <Field
                      className="form-control"
                      name="firstName"
                      type="text"
                    />
                    <ErrorMessage name="firstName" component="div" className="invalid-feedback" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label>Apellido <span className="text-danger">*</span></label>
                    <Field
                      className="form-control"
                      name="lastName"
                      type="text"
                    />
                    <ErrorMessage name="lastName" component="div" className="invalid-feedback" />
                  </div>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <div className="form-group">
                    <label>Tipo de documento</label>
                    <select
                      className="form-control"
                      value={this.state.docType}
                      onChange={e => {
                        const valor = e.target.value;
                        this.setState({ docType: valor });
                        setFieldValue('docType', valor); 
                      }}
                    >
                      <option value="">Seleccionar...</option>
                      <option value="pasaporte">Pasaporte</option>
                      <option value="dni">DNI</option>
                      <option value="rut">RUT</option>
                    </select>
                  </div>
                </Col>
                <Col>
                  {this.state.docType === 'pasaporte' && (
                    <div className="form-group">
                      <label>Pasaporte <span className="text-danger">*</span></label>
                      <Field
                        className="form-control"
                        name="passport"
                        type="text"
                      />
                      <ErrorMessage name="passport" component="div" className="invalid-feedback" />
                    </div>
                  )}
                  {this.state.docType === 'dni' && (
                    <div className="form-group">
                      <label>DNI <span className="text-danger">*</span></label>
                      <Field
                        className="form-control"
                        name="dni"
                        type="text"
                      />
                      <ErrorMessage name="dni" component="div" className="invalid-feedback" />
                    </div>
                  )}
                  {this.state.docType === 'rut' && (
                    <div className="form-group">
                      <label>RUT <span className="text-danger">*</span></label>
                      <Field
                        className="form-control"
                        name="rut"
                        type="text"
                      />
                      <p>
                        Ej: 123456785
                      </p>
                      <ErrorMessage name="rut" component="div" className="invalid-feedback" />
                    </div>
                  )}
                </Col>
                
              </Row>
              <Row className="mt-3">
                <Col>
                  <div className="form-group">
                    <label>Teléfono celular <span className="text-danger">*</span></label>
                    <Field
                      className="form-control"
                      name="phone"
                      type="text"
                    />
                    <p>Ej: 961234567</p>
                    <ErrorMessage name="phone" component="div" className="invalid-feedback" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label>Email <span className="text-danger">*</span></label>
                    <Field
                      className="form-control"
                      name="email"
                      type="text"
                    />
                    <ErrorMessage name="email" component="div" className="invalid-feedback" />
                  </div>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <div className="form-group">
                    <label>Género <span className="text-danger">*</span></label>
                    <Field as="select" name="gender" className="form-control" onChange={e => { formikHandleChange(e); this.handleChange({ ...values, gender: e.target.value }); }}>
                      <option value="">Seleccionar...</option>
                      <option value="femenino">Femenino</option>
                      <option value="masculino">Masculino</option>
                      <option value="otro">Otro</option>
                      <option value="prefiero_no_decir">Prefiero no decir</option>
                    </Field>
                    <ErrorMessage name="gender" component="div" className="invalid-feedback" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label>Nacionalidad <span className="text-danger">*</span></label>
                    <Field as="select" name="nationality" className="form-control" onChange={e => { formikHandleChange(e); this.handleChange({ ...values, nationality: e.target.value }); }}>
                      <option value="">Seleccionar...</option>
                      <option value="chileno">Chileno</option>
                      <option value="extranjero">Extranjero</option>
                    </Field>
                    <ErrorMessage name="nationality" component="div" className="invalid-feedback" />
                  </div>
                </Col>
              
              </Row>
              <Row className="mt-3">
                <Col>
                  <div className="form-group">
                    <label>
                      <Field
                        type="checkbox"
                        name="acceptTerms"
                        onChange={e => {
                          formikHandleChange(e);
                          this.handleChange({ ...values, acceptTerms: e.target.checked ? 'Si' : 'No' });
                        }}
                      />
                       <span style={{ display: "inline-block", paddingLeft: 5 }}>Autorización de uso de datos personales</span>
                    </label>
                    <p>
                      Acepto que el Ministerio de Relaciones Exteriores efectúe el tratamiento o comunique a otros organismos mis datos, conforme lo establecido al efecto en la Ley 19.628 Sobre Protección de la Vida Privada, con fines estadísticos y para satisfacción usuaria.
                    </p>
                    <ErrorMessage name="acceptTerms" component="div" className="invalid-feedback" />
                  </div>
                </Col>
              </Row>
            </Form>
          )}
          </Formik>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
  };
}

export default connect(mapStateToProps, {
}, null, { forwardRef: true })(Datos);
